
import React from 'react';
import {
    Typography,
} from '@mui/material';
import { useDraggable } from '@dnd-kit/core';
import { display } from '@mui/system';

const DraggableItem = ({ id, name, indicatorColor, isHidden, canEdit }) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({ id, disabled: !canEdit });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition: isDragging ? 'none' : 'transform 0.15s ease',
        zIndex: isDragging ? 1300 : 'auto',
        padding: '10px 14px',
        margin: '6px 0',
        background: canEdit ? '#fff' : '#f4f4f4',
        border: '1px solid #e0e0e0',
        borderRadius: 10,
        boxShadow: isDragging
            ? '0 4px 12px rgba(0,0,0,0.2)'
            : '0 1px 3px rgba(0,0,0,0.08)',
        cursor: canEdit ? 'grab' : 'not-allowed',
        alignItems: 'center',
        gap: 8,
        opacity: isDragging ? 0 : 1,
        display: isHidden ? 'none' : 'flex'
    };
    const listenersOnState = canEdit ? { ...listeners } : undefined;

    return (
        <div ref={setNodeRef} {...listenersOnState} {...attributes} style={style}>
            <span
                style={{
                    width: 3,
                    height: 30,
                    backgroundColor: indicatorColor ?? '#1976d2',
                    borderRadius: 3
                }}
            />
            <Typography variant="body2">{name}</Typography>
        </div>
    );
};
export default DraggableItem;